import styled from "styled-components"
import theme from 'common/theme'
export const  CalendarContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  font-size: 13px;
  row-gap: 1em;

  .month-year-header {
    display: grid;
    grid-template-columns: 1.5em 1fr 1.5em;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }
  }

 
  .calendar-grid {
    font-size: .9em;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-auto-flow: row;
    grid-auto-rows: 1.9em;
    min-width: max-content;
    row-gap: .5em;

    .title-cell {
      font-weight: bold;
      color: ${theme.colors.main};
      font-size: 1em;
      text-align: center;
    }

    button.day-cell {
      border-radius: 1em;
      position: relative;
      background-color: transparent;
      border: none;
      cursor: pointer;
      padding: 0.5em;
      text-align: center;
     
      display: flex;
      align-items: center;
      justify-content: center;
 
      &:not(.is-disabled) {
        color: ${theme.colors.main};
      }
      
      .indicator {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-radius: inhert;
      }

      .label {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      

      &:hover {
        z-index: 1;
       

        .indicator {
          display: block;
          border-color: ${theme.colors.jbtBlue};
          border-style: solid;
          border-width: 1px;
          border-radius: 1em;
        }
      }

     
      &.is-start, &.is-end {
        .indicator {
          display: block;
          background-color: ${theme.colors.jbtBlue};
          border-radius: 1em;
        }
        color: white;
      }
 
      &.is-start {
        border-top-left-radius: 1em!important;
        border-bottom-left-radius: 1em!important;
      }

      &.is-end {
 
        border-top-right-radius: 1em!important;
        border-bottom-right-radius: 1em!important;
 
      }      
    }

  }

  &.has-range button.day-cell.is-in-range {
    background-color:rgb(235, 244, 251);
    border-radius: 0;
 
    border-color: transparent!important;
  }
  
  .calendar-grid:hover button.day-cell.is-in-range {
      background-color:rgb(235, 244, 251);
      border-radius: 0;
     

    }
 
    button.day-cell.is-disabled {
      color: ${theme.colors.grayLight};
      background-color: ${theme.colors.grayLightest};
      pointer-events: none;
      &:not(:first-child),
      &:not(:last-child) {
        border-radius: 0;
      }
      }
    }
`